export default __webpack_public_path__ + "static/media/git_fork.c3f1e99d.svg";